import axios from "axios";
import { PopUpCaller } from "../PopUpWarning/PopUpWarning";

const localhostUrl = "http://localhost:5000"
const ProductUrl = "https://api.lionsragnarokserver.net"
const accessUrl = ProductUrl

const urlUserRegister = accessUrl + "/User/Cadastro"
const urlCheckEmailAvailable = accessUrl + "/User/CheckEmailAvailable"
const urlCheckLionsLoginAvailable = accessUrl + "/User/CheckLoginAvailable"
const urlUserMailConfirm = accessUrl + "/User/EnviarEmailConfirmacao"
const urlUserLogon = accessUrl + "/User/Logon"
const urlUserLogList = accessUrl + "/User/LogListUser"
const urlUserLogRegister = accessUrl + "/User/LogRegister"
const urlVipRequest = accessUrl + "/User/SolicitarVip"
const urlUserHistoricLog = accessUrl + "/User/HistoricLogList"
const urlVipRequestLog = accessUrl + "/User/VipRequestLogList"
const urlMessageList = accessUrl + "/User/MessageList"
const urlMessageStatus = accessUrl + "/User/UpdateMessageStatus"
const urlChangeLionsUserPassword = accessUrl + "/User/UpDateLionsUserPassword"
const urlTicketCreation = accessUrl + "/User/CreateLionsTicket"
const urlTicketList = accessUrl + "/User/GetTicketList"
const urlTicketAnswerList = accessUrl + "/User/GetAnswerList"
const urlUserValidationCodeConfirm  = accessUrl + "/User/ValidarCodigoGerado"
const urlWelcomeBackSession  = accessUrl + "/User/Session"
const urlRecoverPassword  = accessUrl + "/User/RecoverPasswordLions"
const urlItemDbIdRequest  = accessUrl + "/User/ItemDb"
const urlItemDbWordRequest  = accessUrl + "/User/ItemDbWord"
const urlItemDbListRequest  = accessUrl + "/User/ItemDbList"


const API_KEY = "AS7XKLjauheaHN164iylzo2SAJUAHBKUQYTkasNX457";

async function ApiConnectUserRegister(newUser) {

    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    let DTO = {
        id: 0,
        userEmail: newUser.userEmail,
        userName: newUser.userName,
        userPassword: newUser.userPassword,
        birthDate: newUser.birthDate,
        sex: newUser.sex
    }

    let result = await axios.post(urlUserRegister, DTO, config);

    return result;

}

async function ApiConnectEmailAvailable(newUserEmail) {

    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    let emailJson = { email: newUserEmail}
    
    var result = await axios.post(urlCheckEmailAvailable, emailJson, config)
    .then((response) => response.data)
    .catch((error) => error)

    return(result);

}

async function ApiConnectLionsUserAvailable(newUserLogin) {

    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    let newLogin = { login: newUserLogin}
    
    var result = await axios.post(urlCheckLionsLoginAvailable, newLogin, config)
    .then((response) => response.data)
    .catch((error) => error)

    return(result);

}


async function ApiConnectUserLogon(userEmail, userPass) {

    let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };


    let userCredentials = {
        userEmail: userEmail,
        userPassword: userPass
    }

    var result = await axios.post(urlUserLogon, userCredentials, config)
            .then(response => response.data)
            .catch((error) => error)

    return(result);
}

async function ApiConnectEmailConfirm(newUserEmail, newUserName, requestMessage) {


let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');
let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;


    let emailConfirmationJson = {
        email: newUserEmail,
        userName: newUserName,
        message: requestMessage
    }

    
    var result = await axios.post(urlUserMailConfirm, emailConfirmationJson, config)
    .then((response) => response.data)
    .catch((error) => error)

    return(result);

}

async function ApiConnectValidateGeneratedCode(email, code) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    let codeConfirmationDto = {

        userEmail: email,
        validationCode: code,
    }
    
    var result = await axios.post(urlUserValidationCodeConfirm, codeConfirmationDto, config)
    .then((response) => response)
    .catch((error) => error)

    return(result);

}


async function ApiConnectLogList(userData) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    
    var result = await axios.post(urlUserLogList, userData, config)
    .then((response) => response.data)
    .catch((error) => {
        if(error.response.status === 401) {
            return("Unauthorized")
        }

        if(error.response.status === 403) {
            console.log(error.response.status)
            return("Forbidden")
        }
    })


    return(result);

}

async function ApiConnectLogRegister(user, Log) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    const agora = new Date();
    const horaMinutoSegundo = agora.toTimeString().slice(0, 8);
    const ano = agora.getFullYear();
    const mes = (agora.getMonth() + 1).toString().padStart(2, '0');
    const dia = agora.getDate().toString().padStart(2, '0');
    const dataApiFormat = `${ano}-${mes}-${dia}`;

    let newLogData = {
        id: 0,
        userId: user.id,
        userName: user.userName,
        actionDate: dataApiFormat,
        actionDescription: Log + horaMinutoSegundo
}

    var result = await axios.post(urlUserLogRegister, newLogData, config)
    .then((response) => response.data)

    return(result);

}

async function ApiConnectVipRequest(newVipRequest) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

    config.headers.Authorization = `Bearer ${token}`;

    var result = await axios.post(urlVipRequest, newVipRequest, config)
    .then((response) => response.data)
    .catch((error) => error)

    return(result);

}

async function ApiConnectHistoricLog(uName) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    let userCredentials = {
        userName: uName,
    }

    var result = await axios.post(urlUserHistoricLog, userCredentials, config)
            .then(response => response)

    return(result);
}

async function ApiConnectVipRequestLog(userName, userEmail) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    let userCredentials = {
        userName: userName,
        email: userEmail

    }

    var result = await axios.post(urlVipRequestLog, userCredentials, config)
            .then((response) => response)
            .catch((error) => error)    

    return(result);
}

async function ApiConnectMessageListRequest(userName, userEmail) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    let userCredentials = {
        userName: userName,
        email: userEmail

    }

    var result = await axios.post(urlMessageList, userCredentials, config)
            .then((response) => response)  

    return(result);
}

async function ApiConnectMessageReadStatusUpdate(message) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

        let messageDto = {
        messageId : message.messageId,
        messageUserEmail : message.messageUserEmail,
        messageUserName : message.messageUserName
    }

    var result = await axios.post(urlMessageStatus, messageDto, config)
            .then((response) => response.data)
            .catch((error) => error)    

    return(result);
}

async function ApiConnectLionsUserChangePassword(user) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    let result = await axios.put(urlChangeLionsUserPassword, user, config)
    .then(response => response)
    
    return result
}

async function ApiConnectRecoverPassword(user) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    let result = await axios.put(urlRecoverPassword, user, config)
    .then(response => response)
    
    return result
}


async function ApiConnectTicketCreation(ticket) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    var result = await axios.post(urlTicketCreation, ticket, config)
            .then((response) => response)
            .catch((error) => error)    

    return(result);
}

async function ApiConnectTicketListRequest(userName, userEmail) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    let userCredentials = {
        userName: userName,
        email: userEmail

    }

    var result = await axios.post(urlTicketList, userCredentials, config)
            .then((response) => response)
            .catch((error) => error)    

    return(result);
}

async function ApiConnectTicketAnswerListRequest(ticket) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;


    var result = await axios.post(urlTicketAnswerList, ticket, config)
            .then((response) => response.data)
            .catch((error) => error)    

    return(result);
}

async function ApiConnectWelcomeBackSession() {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;

    var result = await axios.get(urlWelcomeBackSession, config);
    return(result)
}

async function ApiConnectItemDb(id) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;


    var result = await axios.get(urlItemDbIdRequest + `/${id}`, config)
            .then((response) => response)
            .catch((error) => error)    

    return(result);
}

async function ApiConnectItemDbWord(filter) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;


    var result = await axios.post(urlItemDbWordRequest, filter, config)
            .then((response) => response)
            .catch((error) => error)    

    return(result);
}

async function ApiConnectItemDbList(interval) {

let token = sessionStorage.getItem('jwtToken'); // Ou sessionStorage.getItem('jwtToken');

let config = {
    headers: {
        'Content-Type': 'application/json',
        'X-API-Key': API_KEY
        },
        validateStatus: function (status) { return true },
    };

config.headers.Authorization = `Bearer ${token}`;


    var result = await axios.get(urlItemDbListRequest + `/${interval}`, config)
            .then((response) => response)
            .catch((error) => error)    

    return(result);
}



export {
        ApiConnectEmailAvailable,
        ApiConnectLionsUserAvailable,
        ApiConnectEmailConfirm,
        ApiConnectValidateGeneratedCode,
        ApiConnectLogList,
        ApiConnectLogRegister,
        ApiConnectUserLogon,
        ApiConnectUserRegister,
        ApiConnectVipRequest,
        ApiConnectHistoricLog,
        ApiConnectVipRequestLog,
        ApiConnectMessageListRequest,
        ApiConnectMessageReadStatusUpdate,
        ApiConnectLionsUserChangePassword,
        ApiConnectTicketCreation,
        ApiConnectTicketListRequest,
        ApiConnectTicketAnswerListRequest,
        ApiConnectWelcomeBackSession,
        ApiConnectRecoverPassword,
        //ApiConnectItemDb,
        //ApiConnectItemDbWord,
        //ApiConnectItemDbList
    };